import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { useModal } from 'reservations/base/providers/ModalProvider';
import BaseTipModal from 'reservations/checklessPayments/components/BaseTipModal';
import { SaveChecklessButton } from 'reservations/checklessPayments/components/SaveChecklessButon';
import { SaveExistingPaymentButton } from 'reservations/checklessPayments/components/SavePaymentButton';

const UpdateTipModal = () => {
  const hasVisitId = useHasVisitId();
  const { close } = useModal();

  return (
    <BaseTipModal
      Button={hasVisitId ? SaveChecklessButton : SaveExistingPaymentButton}
      handleClick={close}
    />
  );
};

export default UpdateTipModal;
